import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation UpdateRole($id: Int!) {
    deleteRole(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteRole: {
    id?: number;
  };
}
